import React, { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";
import "../../dashboard/reporttable.css";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", };

const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "flex", alignItems: "center", gap: 5, };
const TogglePill = ({
  label,
  icon,
  checked,
  onChange,
  disabled = false,
}) => (
  <label
    style={{
      display: "flex", alignItems: "center", gap: 6, padding: "8px 16px", borderRadius: 999, border: "1px solid #2E7D32", cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, background: checked ? "#E8F5E9" : "#fff",
    }}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      style={{ display: "none" }}
    />
    <i className={`mdi ${icon}`} />
    {label}
  </label>
);

const EcoTourismReview = () => {
  const Api = process.env.REACT_APP_API;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [circles, setCircles] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [jfmcTypes, setJfmcTypes] = useState([]);
  const [reviewData, setReviewData] = useState([]);
  const today = new Date();
  const [selectedMonth, setSelectedMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth()).padStart(2, "0")}`
  );
  const [year, month] = selectedMonth.split("-");
  const [selectedCircle, setSelectedCircle] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedJfmcType, setSelectedJfmcType] = useState("");
  const [showCircle, setShowCircle] = useState(false);
  const [showDivision, setShowDivision] = useState(false);
  const [expandedDivisions, setExpandedDivisions] = useState({});
  const [expandedRanges, setExpandedRanges] = useState({});
  /* -------------------------------------- */
  const fetchMasterData = async () => {
    try {
      const config = Authorization();

      const [circleRes, divisionRes, jfmcRes] = await Promise.all([
        axios.get(`${Api}/api/circles`, config),
        axios.get(`${Api}/api/divisions`, config),
        axios.get(`${Api}/api/jfmc-types`, config),
      ]);

      setCircles(circleRes.data || []);
      setDivisions(divisionRes.data || []);

      const jfmcTypeList = jfmcRes.data || [];
      setJfmcTypes(jfmcTypeList);

      // Automatically select VFC JFMC Type
      // const defaultJfmcType = jfmcTypeList.find(
      //   (item) => item.jfmcTypeName === "EDC"
      // );

      // if (defaultJfmcType) {
      //   setSelectedJfmcType(defaultJfmcType._id);
      // }
    } catch (err) {
      console.error(err);
      setError("Failed to load filters.");
    }
  };
  /* -------------------------------------- */
  const fetchEcoTourismReview = async (jfmcTypeId = selectedJfmcType) => {
    try {
      setLoading(true);

      const config = Authorization();

      const res = await axios.get(
        `${Api}/api/eco-tourism-table/review`,
        {
          ...config,
          params: {
            month,
            year,
            circleId: selectedCircle || undefined,
            divisionId: selectedDivision || undefined,
            jfmcTypeId: jfmcTypeId || undefined,
          },
        }
      );

      setReviewData(res.data.data || []);
    } catch (error) {
      console.error("Bank balance Review Error:", error);

      setReviewData([])
      // Optional: show a toast or alert
      toast.error(
        error.response?.data?.message || "Failed to load Eco Tourism review data."
      );

    } finally {
      setLoading(false);
    }
  };

  /* -------------------------------------- */
  useEffect(() => {
    fetchMasterData();
  }, []);
  /* -------------------------------------- */
  useEffect(() => {
    fetchEcoTourismReview();
  }, [selectedMonth, selectedCircle, selectedDivision, selectedJfmcType]);
  const activeJfmc =
    jfmcTypes.find(item => item._id === selectedJfmcType) || {
      jfmcTypeName: "All JFMC Types",
    };
  /* -------------------------------------- */
  const badge = (value, type) => {
    const styles = {
      total: {
        bg: "#EEF2FF",
        color: "#3730A3",
      },
      held: {
        bg: "#DCFCE7",
        color: "#166534",
      },
      pending: {
        bg: "#FEE2E2",
        color: "#991B1B",
      },
    };
    const style = styles[type];
    return (
      <span
        style={{ display: "inline-block", minWidth: 40, textAlign: "center", padding: "4px 10px", borderRadius: 20, background: style.bg, color: style.color, fontWeight: 600, fontSize: 12, }}>
        {value}
      </span>
    );
  };
  /* ---------------- Summary ---------------- */
  const totals = reviewData.reduce(
    (acc, item) => {
      acc.totalCenters += item.totalCenters || 0;
      acc.submitted += item.submitted || 0;
      acc.pending += item.pending || 0;
      acc.totalRevenue += Number(item.totalRevenue || 0);
      acc.totalVisitors += Number(item.totalVisitors || 0);
      acc.totalWorkers += Number(item.totalWorkers || 0);
      acc.totalRooms += Number(item.totalRooms || 0);

      return acc;
    },
    {
      totalCenters: 0,
      submitted: 0,
      pending: 0,
      totalRevenue: 0,
      totalVisitors: 0,
      totalWorkers: 0,
      totalRooms: 0,
    }
  );
  const toggleDivision = (id) => {
    setExpandedDivisions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const toggleRange = (id) => {
    setExpandedRanges(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  /* -------------------------------------- */
  const exportEcoTourismReport = () => {

    if (!reviewData || reviewData.length === 0) {
      alert("No Eco Tourism data available to export");
      return;
    }

    const calculatePercentage = (completed, total) => {
      if (!total || total === 0) {
        return "0.00%";
      }
      return `${((completed / total) * 100).toFixed(2)}%`;
    };

    let reportYear;
    let reportMonth;

    if (
      typeof month === "string" &&
      /^\d{4}-\d{2}$/.test(month)
    ) {
      const [y, m] = month.split("-");
      reportYear = Number(y);
      reportMonth = Number(m);
    } else {
      reportYear = Number(year);
      reportMonth = Number(month);
    }

    const monthDate = new Date(
      reportYear,
      reportMonth - 1,
      1
    );
    const monthName = monthDate.toLocaleString(
      "en-US",
      {
        month: "long"
      }
    );

    const reportTitle =
      `Eco Tourism Summary for the Month of ${monthName} ${reportYear}`;

    let nameColumn = "Circle";

    if (selectedRange) {
      nameColumn = "VFC";
    } else if (selectedDivision) {
      nameColumn = "Range";
    } else if (selectedCircle) {
      nameColumn = "Division";
    }

    const excelData = reviewData.map((item) => {

      let total = 0;

      if (selectedRange) {
        total = 1;
      } else {
        total = Number(
          item.totalCenters || 0
        );
      }

      const submitted = selectedRange
        ? item.submitted
          ? 1
          : 0
        : Number(
          item.submitted || 0
        );

      const pending = Math.max(
        total - submitted,
        0
      );

      const completionPercentage =
        calculatePercentage(
          submitted,
          total
        );

      const totalRevenue =
        Number(
          item.totalRevenue || 0
        );

      if (selectedRange) {
        return {
          [nameColumn]:
            item.vfcName ||
            item.name ||
            "-",
          "Status":
            item.submitted
              ? "Submitted"
              : "Pending",
          "Total Eco Centers":
            total,
          "Submitted":
            submitted,
          "Pending":
            pending,
          "Completion %":
            completionPercentage,
          "Total Revenue":
            totalRevenue
        };
      }

      return {

        [nameColumn]:
          selectedDivision
            ? (
              item.rangeName ||
              item.name ||
              "-"
            )

            : selectedCircle
              ? (
                item.divisionName ||
                item.name ||
                "-"
              )

              : (
                item.circleName ||
                item.name ||
                "-"
              ),
        "Total Eco Centers":
          total,
        "Submitted":
          submitted,
        "Pending":
          pending,
        "Completion %":
          completionPercentage,
        "Total Revenue":
          totalRevenue
      };
    });

    if (excelData.length === 0) {

      alert(
        "No Eco Tourism data available to export"
      );

      return;
    }

    const headers =
      Object.keys(excelData[0]);

    const rows =
      excelData.map((row) =>
        headers.map(
          (header) => row[header]
        )
      );

    const worksheet =
      XLSX.utils.aoa_to_sheet([
        [reportTitle],
        [],
        headers,
        ...rows
      ]);

    worksheet["!merges"] = [
      {
        s: {
          r: 0,
          c: 0
        },
        e: {
          r: 0,
          c: headers.length - 1
        }
      }
    ];

    worksheet["!cols"] =
      headers.map((header) => ({
        wch: Math.max(
          header.length + 3,
          20
        )

      }));

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Eco Tourism Progress"
    );

    let level = "Circle";

    if (selectedRange) {

      level = "VFC";

    } else if (selectedDivision) {

      level = "Range";

    } else if (selectedCircle) {

      level = "Division";
    }

    const fileName =
      `Eco_Tourism_${level}_${monthName}_${reportYear}.xlsx`;
    XLSX.writeFile(
      workbook,
      fileName
    );
  };
  if (loading) return <Preloader loading />;
  if (error) return <p className="text-danger">{error}</p>;
  return <div><div className="rd-page-header">
    <div className="rd-header-left">
      <span className="page-title-icon">
        <i className="mdi mdi-clipboard-check-multiple-outline" />
      </span>
      <div>
        <h3 className="rd-page-title">
          Eco Tourism Review Dashboard
        </h3>
        <p className="rd-page-sub">
          Month-wise Eco Tourism Progress
        </p>
      </div>
    </div>
  </div>
    {/* ---------------- Filters ---------------- */}
    <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", padding: "20px 24px", marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
        <span style={{ width: 30, height: 30, background: "linear-gradient(135deg,#1B5E20,#43A047)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 14 }}>
          <i className="mdi mdi-filter-variant" />
        </span>
        <span style={{ fontSize: 13, fontWeight: 700, color: "#1A202C" }}>Filter Report</span>
        <span style={{ fontSize: 11, color: "#A0AEC0", marginLeft: 4 }}>Toggle filters and select a date to view records</span>
      </div>
      {/* Toggle pills */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
        <TogglePill label="Circle" icon="mdi-circle-outline" checked={showCircle} disabled={showDivision} onChange={(e) => { setShowCircle(e.target.checked); if (!e.target.checked) setSelectedCircle(""); }} />
        <TogglePill label="Division" icon="mdi-domain" checked={showDivision} disabled={showCircle} onChange={(e) => { setShowDivision(e.target.checked); if (!e.target.checked) setSelectedDivision(""); }} />
      </div>
      {/* Conditional selects */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0,1fr))", gap: 12, marginBottom: 16 }}>
        <div >
          <label style={labelStyle}>
            <i
              className="mdi mdi-calendar-month"
              style={{ color: "#43A047" }}
            />
            Month
          </label>
          <input
            type="month"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>
            <i
              className="mdi mdi-shape-outline"
              style={{ color: "#43A047" }}
            />
            JFMC Type
          </label>
          <select
            value={selectedJfmcType}
            onChange={(e) => setSelectedJfmcType(e.target.value)}
            style={inputStyle}
          >
            <option value="">All JFMC Types</option>
            {jfmcTypes
              .sort((a, b) => a.jfmcTypeName.localeCompare(b.jfmcTypeName))
              .map((j) => (
                <option key={j._id} value={j._id}>
                  {j.jfmcTypeName}
                </option>
              ))}
          </select>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0,1fr))", gap: 12, marginBottom: 16 }}>{showCircle && (
        <div>
          <label style={labelStyle}><i className="mdi mdi-circle-outline" style={{ color: "#43A047" }} /> Circle</label>
          <select value={selectedCircle} onChange={(e) => setSelectedCircle(e.target.value)} style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
            <option value="">— Select —</option>
            {circles.sort((a, b) => a.circleName.localeCompare(b.circleName)).map((c) => <option key={c._id} value={c._id}>{c.circleName}</option>)}
          </select>
        </div>
      )}
        {showDivision && (
          <div>
            <label style={labelStyle}><i className="mdi mdi-domain" style={{ color: "#43A047" }} /> Division</label>
            <select value={selectedDivision} onChange={(e) => setSelectedDivision(e.target.value)} style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"}>
              <option value="">— Select —</option>
              {divisions.sort((a, b) => a.divisionName.localeCompare(b.divisionName)).map((d) => <option key={d._id} value={d._id}>{d.divisionName}</option>)}
            </select>
          </div>
        )}
      </div>
    </div>
    <div className="dashboard-sections">
      <div className="jfmc-section">
        <h3 className="jfmc-title">
          {activeJfmc.jfmcTypeName} — Compliance Overview
        </h3>
        <div
          key={activeJfmc.jfmcTypeId}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
            gap: 16,
          }}
        >
          {/* Eco Centers */}
          <div className="stat-card card-purple stat-centered">
            <div className="stat-icon-big icon-purple">
              <i className="fas fa-users-cog" />
            </div>
            <div className="stat-title">
              Total Center
            </div>
            <div
              style={{
                fontSize: 34,
                fontWeight: 700,
                marginTop: 12,
              }}
            >
              {totals.totalCenters}
            </div>
          </div>
          {/* Meetings Held */}
          <div className="stat-card card-green stat-centered">
            <div className="stat-icon-big icon-green">
              <i className="fas fa-check-circle" />
            </div>
            <div className="stat-title">
              Submitted            </div>
            <div
              style={{
                fontSize: 34,
                fontWeight: 700,
                marginTop: 12,
              }}
            >
              {totals.submitted}
            </div>
          </div>
          {/* Meetings Not Held */}
          <div className="stat-card card-orange stat-centered">
            <div className="stat-icon-big icon-orange">
              <i className="fas fa-times-circle" />
            </div>
            <div className="stat-title">
              Revenue Not Added
            </div>
            <div
              style={{
                fontSize: 34,
                fontWeight: 700,
                marginTop: 12,
              }}
            >
              {totals.pending}
            </div>
          </div>
          <div className="stat-card card-teal stat-centered">
            <div className="stat-icon-big icon-teal">
              <i className="fas fa-university" />
            </div>
            <div className="stat-title">
              Total Revenue Amount
            </div>

            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                marginTop: 12,
              }}
            >
              ₹ {(totals.totalRevenue || 0).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
    {(selectedCircle || selectedDivision || selectedRange) && (
      <button
        className="btn btn-outline-secondary mb-3"
        onClick={() => {
          if (selectedRange) {
            setSelectedRange("");
          } else if (selectedDivision) {
            setSelectedDivision("");
          } else if (selectedCircle) {
            setSelectedCircle("");
          }
        }}
      >
        <i className="mdi mdi-arrow-left me-1" />
        Back
      </button>
    )}
    {/* ---------------- Summary Table ---------------- */}
    <div
      style={{
        marginTop: 24,
        background: "#fff",
        borderRadius: 12,
        border: "1px solid #E2E8F0",
        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
        overflow: "hidden",
      }}
    >
      {/* Card Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "14px 20px",
          borderBottom: "1px solid #EDF2F7",
        }}
      >
        <span
          style={{
            width: 36,
            height: 36,
            background: "linear-gradient(135deg,#1B5E20,#43A047)",
            borderRadius: 9,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 16,
          }}
        >
          <i className="mdi mdi-table-large" />
        </span>
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#1A202C",
            }}
          >
            Eco Tourism Summary
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#A0AEC0",
            }}
          >
            {selectedRange
              ? "VFC Wise"
              : selectedDivision
                ? "Range Wise"
                : selectedCircle
                  ? "Division Wise"
                  : "Circle Wise"}
          </div>
        </div>
        {/* Button at the end/right */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "auto",
          }}
          className="jfmc-switch"
        >
          <button
            onClick={exportEcoTourismReport}
            className="btn btn-success"
          >
            Export Excel
          </button>
        </div>
      </div>
      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <table
          style={{ width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}
        >
          <thead>
            <tr
              style={{
                background: "#2E7D32",
                color: "#fff",
              }}
            >
              <th style={{ padding: 12, textAlign: "left" }}>
                {selectedRange
                  ? "VFC"
                  : selectedDivision
                    ? "Range"
                    : selectedCircle
                      ? "Division"
                      : "Circle"}
              </th>
              {selectedRange ? (
                <>
                  <th style={{ padding: 12, textAlign: "center" }}>
                    Status
                  </th>
                  <th style={{ padding: 12, textAlign: "right" }}>
                    Bank Balance
                  </th>
                  <th style={{ padding: 12, textAlign: "center" }}>
                    Date Of Execution
                  </th>
                </>
              ) : (
                <>
                  <th style={{ padding: 12, textAlign: "center" }}>
                    Eco Centers
                  </th>
                  <th style={{ padding: 12, textAlign: "center" }}>
                    Submitted
                  </th>
                  <th style={{ padding: 12, textAlign: "center" }}>
                    Pending
                  </th>
                  <th style={{ padding: 12, textAlign: "right" }}>
                    Total Revenue
                  </th>
                  <th style={{ padding: 12 }}>
                    {selectedCircle
                      ? "Range Progress"
                      : selectedDivision
                        ? "VFC Progress"
                        : "Division Progress"}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {reviewData.length === 0 ? (
              <tr>
                <td
                  colSpan={selectedRange ? 4 : 7}
                  style={{
                    textAlign: "center",
                    padding: 30,
                    color: "#999",
                  }}
                >
                  No Records Found
                </td>
              </tr>
            ) : (
              reviewData.map((item, index) => (
                <tr
                  key={item._id}
                  style={{
                    background: index % 2 === 0 ? "#fff" : "#F8FAFD",
                  }}
                >
                  <td
                    style={{
                      padding: "12px 15px",
                      color: "#1565C0",
                    }}
                  >
                    <div style={{ fontWeight: 600 }}>
                      <i
                        className="mdi mdi-map-marker-outline"
                        style={{ marginRight: 5 }}
                      />
                      {item.circleName || item.divisionName || item.rangeName}
                    </div>

                    {!selectedCircle && !selectedDivision && (
                      <div
                        style={{
                          fontSize: 11,
                          color: "#6B7280",
                          marginTop: 4,
                        }}
                      >
                        Last Updated :{" "}
                        {item.lastUpdated
                          ? new Date(item.lastUpdated).toLocaleDateString("en-GB")
                          : "-"}
                      </div>
                    )}
                  </td>
                  {selectedRange ? (
                    <>
                      <td style={{ textAlign: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "5px 12px",
                            borderRadius: 20,
                            fontSize: 12,
                            fontWeight: 600,
                            background: item.submitted ? "#DCFCE7" : "#FEE2E2",
                            color: item.submitted ? "#166534" : "#991B1B",
                          }}
                        >
                          {item.submitted ? "Submitted" : "Pending"}
                        </span>
                      </td>

                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 15,
                          fontWeight: 600,
                        }}
                      >
                        ₹{" "}
                        {Number(item.totalRevenue || 0).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                        })}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {item.lastUpdated
                          ? new Date(item.lastUpdated).toLocaleDateString("en-GB")
                          : "-"}
                      </td>
                    </>
                  ) : (
                    <>
                      <td style={{ textAlign: "center" }}>
                        {badge(item.totalCenters, "total")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {badge(item.submitted, "held")}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {badge(item.pending, "pending")}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          paddingRight: 15,
                          fontWeight: 600,
                        }}
                      >
                        ₹{" "}
                        {Number(
                          item.totalRevenue || 0
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                        })}
                      </td>
                      <td style={{ padding: 12, minWidth: 520 }}>
                        {!selectedCircle ? (
                          (() => {
                            const completedDivisionIds = new Set(
                              (item.completedDivisions || []).map(d => d._id)
                            );
                            const divisions = [
                              ...(item.completedDivisions || []).map(d => ({
                                ...d,
                                status: "completed"
                              })),
                              ...(item.pendingDivisions || [])
                                .filter(d => !completedDivisionIds.has(d._id))
                                .map(d => ({
                                  ...d,
                                  status: "pending"
                                }))
                            ];
                            return divisions.map(division => (
                              <div
                                key={division._id}
                                style={{
                                  marginBottom: 15,
                                  border: "1px solid #E5E7EB",
                                  borderRadius: 10,
                                  overflow: "hidden"
                                }}
                              >
                                <div
                                  onClick={() => toggleDivision(division._id)}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "12px 15px",
                                    cursor: "pointer",
                                    background:
                                      division.status === "completed"
                                        ? "#ECFDF5"
                                        : "#FEF2F2"
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: "#666"
                                    }}
                                  >
                                    Submitted {division.submitted}/{division.totalCenters}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: 11,
                                      color: "#6B7280",
                                      marginTop: 2
                                    }}
                                  >
                                    Last Updated :{" "}
                                    {division.lastUpdated
                                      ? new Date(division.lastUpdated).toLocaleDateString("en-GB")
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 15
                                    }}
                                  >
                                    <strong>
                                      ₹ {Number(
                                        division.totalRevenue || 0
                                      ).toLocaleString("en-IN")}
                                    </strong>
                                    <i
                                      className={`mdi ${expandedDivisions[division._id]
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                        }`}
                                      style={{ fontSize: 22 }}
                                    />
                                  </div>
                                </div>
                                {expandedDivisions[division._id] && (
                                  <>
                                    {(division.completedRanges || []).map(range => (

                                      <div
                                        key={range._id}
                                        style={{
                                          borderTop: "1px solid #E5E7EB"
                                        }}
                                      >
                                        <div
                                          onClick={() => toggleRange(range._id)}
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "10px 18px",
                                            cursor: "pointer",
                                            background: "#FAFAFA"
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#666"
                                            }}
                                          >
                                            Submitted {range.submitted}/{range.totalCenters}
                                          </div>

                                          <div
                                            style={{
                                              fontSize: 11,
                                              color: "#6B7280",
                                              marginTop: 2
                                            }}
                                          >
                                            Last Updated :{" "}
                                            {range.lastUpdated
                                              ? new Date(range.lastUpdated).toLocaleDateString("en-GB")
                                              : "-"}
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: 15,
                                              alignItems: "center"
                                            }}
                                          >
                                            <strong>
                                              ₹ {Number(
                                                range.totalRevenue || 0
                                              ).toLocaleString("en-IN")}
                                            </strong>
                                            <i
                                              className={`mdi ${expandedRanges[range._id]
                                                ? "mdi-chevron-up"
                                                : "mdi-chevron-down"
                                                }`}
                                            />
                                          </div>
                                        </div>
                                        {/* VFC Details */}
                                        {expandedRanges[range._id] && (
                                          <div
                                            style={{
                                              padding: "8px 25px"
                                            }}
                                          >
                                            {(range.completedCenters || []).map(center => (
                                              <div
                                                key={center._id}
                                                style={{
                                                  marginBottom: 12,
                                                  border: "1px solid #E5E7EB",
                                                  borderRadius: 8,
                                                  background: "#fff",
                                                  padding: 12,
                                                }}
                                              >
                                                {/* Header */}

                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: 12,
                                                  }}
                                                >
                                                  <div>
                                                    <div
                                                      style={{
                                                        fontWeight: 700,
                                                        color: "#14532D",
                                                        fontSize: 14,
                                                      }}
                                                    >
                                                      {center.ecoTourismName}
                                                    </div>

                                                    <div
                                                      style={{
                                                        fontSize: 12,
                                                        color: "#666",
                                                      }}
                                                    >
                                                      {center.vfcName}
                                                    </div>
                                                  </div>

                                                  <span
                                                    style={{
                                                      background: "#DCFCE7",
                                                      color: "#166534",
                                                      padding: "4px 10px",
                                                      borderRadius: 20,
                                                      fontSize: 11,
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Submitted
                                                  </span>
                                                </div>

                                                {/* Statistics */}

                                                <div
                                                  style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(3,minmax(120px,1fr))",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <div>
                                                    <strong>Visitors</strong>
                                                    <br />
                                                    {center.totalVisitors ?? 0}
                                                  </div>

                                                  <div>
                                                    <strong>Adults</strong>
                                                    <br />
                                                    {center.adults ?? 0}
                                                  </div>

                                                  <div>
                                                    <strong>Children</strong>
                                                    <br />
                                                    {center.children ?? 0}
                                                  </div>

                                                  <div>
                                                    <strong>Workers</strong>
                                                    <br />
                                                    {center.totalWorkers ?? 0}
                                                  </div>

                                                  <div>
                                                    <strong>Rooms</strong>
                                                    <br />
                                                    {center.totalRooms ?? 0}
                                                  </div>

                                                  <div>
                                                    <strong>Revenue</strong>
                                                    <br />
                                                    ₹ {Number(center.totalRevenue || 0).toLocaleString("en-IN")}
                                                  </div>
                                                </div>

                                                <div
                                                  style={{
                                                    marginTop: 10,
                                                    fontSize: 12,
                                                    color: "#666",
                                                  }}
                                                >
                                                  <strong>Last Updated :</strong>{" "}
                                                  {center.lastUpdated
                                                    ? new Date(center.lastUpdated).toLocaleDateString("en-GB")
                                                    : "-"}
                                                </div>
                                              </div>
                                            ))}

                                          </div>

                                        )}

                                      </div>

                                    ))}

                                    {(division.pendingRanges || []).map(range => (

                                      <div
                                        key={range._id}
                                        style={{
                                          padding: "10px 18px",
                                          borderTop: "1px solid #F3F4F6",
                                          background: "#FFF7F7",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          color: "#B91C1C",
                                          fontWeight: 600
                                        }}
                                      >

                                        <span>Range : {range.rangeName}</span>

                                        <span>
                                          0/{range.totalCenters}
                                        </span>

                                      </div>

                                    ))}

                                  </>

                                )}

                              </div>

                            ));

                          })()

                        ) : (

                          (() => {

                            const completedRangeIds = new Set(
                              (item.completedRanges || []).map(r => r._id)
                            );

                            const ranges = [
                              ...(item.completedRanges || []).map(r => ({
                                ...r,
                                status: "completed"
                              })),
                              ...(item.pendingRanges || [])
                                .filter(r => !completedRangeIds.has(r._id))
                                .map(r => ({
                                  ...r,
                                  status: "pending"
                                }))
                            ];

                            return ranges.map(range => (

                              <div
                                key={range._id}
                                style={{
                                  marginBottom: 15,
                                  border: "1px solid #E5E7EB",
                                  borderRadius: 10,
                                  overflow: "hidden"
                                }}
                              >

                                <div
                                  onClick={() => toggleRange(range._id)}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "12px 15px",
                                    cursor: "pointer",
                                    background:
                                      range.status === "completed"
                                        ? "#ECFDF5"
                                        : "#FEF2F2"
                                  }}
                                >

                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: "#666"
                                    }}
                                  >
                                    Submitted {range.submitted}/{range.totalCenters}
                                  </div>

                                  <div
                                    style={{
                                      fontSize: 11,
                                      color: "#6B7280",
                                      marginTop: 2
                                    }}
                                  >
                                    Last Updated :{" "}
                                    {range.lastUpdated
                                      ? new Date(range.lastUpdated).toLocaleDateString("en-GB")
                                      : "-"}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 15
                                    }}
                                  >
                                    <strong>
                                      ₹ {Number(
                                        range.totalRevenue || 0
                                      ).toLocaleString("en-IN")}
                                    </strong>
                                    <i
                                      className={`mdi ${expandedRanges[range._id]
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                        }`}
                                    />
                                  </div>
                                </div>
                                {expandedRanges[range._id] && (
                                  <div
                                    style={{
                                      padding: "8px 25px"
                                    }}
                                  >
                                    {(range.completedCenters || []).map(center => (
                                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, fontSize: 12, marginTop: 8 }}>
                                        <div>
                                          <strong>Visitors</strong><br />
                                          {center.totalVisitors ?? 0}
                                        </div>
                                        <div>
                                          <strong>Adults</strong><br />
                                          {center.adults ?? 0}
                                        </div>
                                        <div>
                                          <strong>Children</strong><br />
                                          {center.children ?? 0}
                                        </div>
                                        <div>
                                          <strong>Revenue</strong><br />
                                          ₹ {Number(center.totalRevenue || 0).toLocaleString("en-IN")}
                                        </div>
                                        <div>
                                          <strong>Workers</strong><br />
                                          {center.totalWorkers ?? 0}
                                        </div>
                                        <div>
                                          <strong>Rooms</strong><br />
                                          {center.totalRooms ?? 0}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ));
                          })()
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>;
};

export default EcoTourismReview;
